import React from 'react'

import styled from '@emotion/styled'
import {
  AlignItems,
  Body2,
  Bold,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading3,
  JustifyContent,
  TextAlign,
} from '@gousto-internal/citrus-react'

const FriendDiscountBox = styled(Box)`
  border-radius: 4px;
`

const DiscountContainer = styled(Box)`
  gap: 28px;

  @media (max-width: 1023px) {
    gap: 16px;
  }
`

interface Props {
  discount: string
  description: React.ReactNode
  bgColor: Color
}

export const RafDiscountStep = ({ discount, description, bgColor }: Props) => (
  <DiscountContainer
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    alignItems={AlignItems.Center}
  >
    <FriendDiscountBox
      display="flex"
      flexDirection={FlexDirection.Column}
      bg={bgColor}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      paddingV={4}
      paddingH={4}
      height={['80px', '80px', '96px']}
      width={['80px', '80px', '96px']}
    >
      <Heading3 color={Color.White}>{discount}</Heading3>
      <Heading3 color={Color.White}>OFF</Heading3>
    </FriendDiscountBox>
    <Body2 color={Color.ColdGrey_800} textAlign={TextAlign.Center}>
      <Bold>{description}</Bold>
    </Body2>
  </DiscountContainer>
)
